import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../../api.base';

export class APIListEnterpriseDeviceGroupManager extends APIBaseManager<void, void, void, any> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_ListEnterpriseDeviceGroup';
        this._apiMethod = 'GET';
    }

    protected getRequestURL(pathParameters: void, queryParameters: void): string {
        return super.getRequestURL() + 'enterprises/deviceGroups';
    }
}